import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import fordStyles from "./FieldReporting-Ford.module.scss";
import fordStylesOverride from "./FieldReportingFordStylesOverride";
import lincolnStylesOverride from "./FieldReportingLincolnStylesOverride";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import {
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  Grid,
  FormControl,
} from "@mui/material";
import DatePicker from "react-datepicker";
import * as DateConstants from "../../shared/constants/DateConstants";
import checkboxStyles from "../../shared/checkBox/CheckBox.module.scss";
import Reset from "@mui/icons-material/Replay";
import DatePickerIcon from "../../imgs/DatePickerIcon";
import ReservationsPreview from "./reportPreview/ReservationsPreview";
import PurchaseRequestPreview from "./reportPreview/PurchaseRequestPreview";
import OrdersPreview from "./reportPreview/OrdersPreview";
import UpperCaseText from "../../utils/UpperCaseText";
import UiDateUtils from "../../utils/UiDateUtils";
import { base64FileDownload } from "../../utils/FileDownloadUtil";
import { logMsg } from "../../common/Logger";
import { IS_FORD_BRAND, IS_USA_MARKET } from "../../utils/EmpUtil";
import lincolnStyles from "./FieldReporting-Lincoln.module.scss";
import { publish } from "../../common/PubSub";
import VehicleLinesClient from "../../clients/VehicleLinesClient";
import DealerReportingClient from "../../clients/DealerReportingClient";
import DealerGroupingClient from "../../clients/DealerGroupingClient";
import LocationDataClient from "../../clients/LocationDataClient";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import EMPButton from "../../shared/components/EMPButton/EMPButton";
import EMPSelectField from "../../shared/components/EMPSelectField/EMPSelectField";

let styles = fordStyles;
let isFordBrand = true;
let stylesOverride = fordStylesOverride;

const FieldReporting = (props) => {
  const salesCodeInput = useRef(null);
  const [reportData, setReportData] = useState("");
  const [base64String, setBase64String] = useState("");
  const [vehicleLines, setVehicleLines] = useState({});
  const [brand, setBrand] = useState(
    props.brand === "F" ? "Ford Brand" : "Lincoln Brand"
  );
  const [brands, setBrands] = useState([
    props.t("fieldReporting.dropDowns.fordBrand"),
    props.t("fieldReporting.dropDowns.lincolnBrand"),
  ]);
  const [reportType, setReportType] = useState(
    props.t("fieldReporting.dropDowns.purchaseRequest")
  );
  const [reportTypes, setReportTypes] = useState([
    props.t("fieldReporting.dropDowns.reservationsConversions"),
    props.t("fieldReporting.dropDowns.ordersConversions"),
    props.t("fieldReporting.dropDowns.purchaseRequest"),
  ]);
  const [model, setModel] = useState(props.t("fieldReporting.dropDowns.all"));
  const [modelYears, setModelYears] = useState([]);
  const [modelYear, setModelYear] = useState(props.t("fieldReporting.dropDowns.all"));
  const [marketArea, setMarketArea] = useState(
    props.t("fieldReporting.dropDowns.select")
  );
  const [marketAreas, setMarketAreas] = useState([]);
  const [region, setRegion] = useState(props.t("fieldReporting.dropDowns.select"));
  const [regions, setRegions] = useState([]);
  const [zone, setZone] = useState(props.t("fieldReporting.dropDowns.select"));
  const [zones, setZones] = useState([]);
  const [dealership, setDealership] = useState(
    props.t("fieldReporting.dropDowns.select")
  );
  const [dealerships, setDealerships] = useState([]);
  const [allRegions, setAllRegions] = useState(null);
  const [regionsByMarketArea, setRegionsByMarketArea] = useState(null);
  const [zonesByMarketArea, setZonesByMarketArea] = useState(null);
  const [zonesByRegion, setZonesByRegion] = useState(null);
  const [fordDealershipsByZone, setFordDealershipsByZone] = useState(null);
  const [lincolnDealershipsByZone, setLincolnDealershipsByZone] = useState(null);
  const [salesCodeMap, setSalesCodeMap] = useState(null);
  const [dateRange, setDateRange] = useState(
    props.t("fieldReporting.dropDowns.last30Days")
  );
  const [dateRanges, setDateRanges] = useState([
    props.t("fieldReporting.dropDowns.last30Days"),
    props.t("fieldReporting.dropDowns.last90Days"),
    props.t("fieldReporting.dropDowns.yearToDate"),
  ]);
  const [previouslySelectedReportType, setPreviouslySelectedReportType] = useState(
    null
  );
  const [searchBySalesCode, setSearchBySalesCode] = useState(false);
  const [salesCode, setSalesCode] = useState(null);
  const [invalidSalesCodeError, setInvalidSalesCodeError] = useState(false);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [transactionDataChecked, setTransactionDataChecked] = useState(false);
  const [tradeInDataChecked, setTradeInDataChecked] = useState(false);
  const [dateRangeMethod, setDateRangeMethod] = useState("auto");
  const [renderPreview, setRenderPreview] = useState(false);
  const [renderDealerDetailsSection, setRenderDealerDetailsSection] = useState(false);
  const [allZones, setAllZones] = useState(null);
  const [dealerInfo, setDealerInfo] = useState(null);

  const state = {
    reportData,
    base64String,
    vehicleLines,
    brand,
    brands,
    reportType,
    reportTypes,
    model,
    modelYears,
    modelYear,
    marketArea,
    marketAreas,
    region,
    regions,
    zone,
    zones,
    dealership,
    dealerships,
    allRegions,
    regionsByMarketArea,
    zonesByMarketArea,
    zonesByRegion,
    fordDealershipsByZone,
    lincolnDealershipsByZone,
    salesCodeMap,
    dateRange,
    dateRanges,
    previouslySelectedReportType,
    searchBySalesCode,
    salesCode,
    invalidSalesCodeError,
    fromDate,
    toDate,
    transactionDataChecked,
    tradeInDataChecked,
    dateRangeMethod,
    renderPreview,
    renderDealerDetailsSection,
    allZones,
    dealerInfo,
  };

  const stateSetters = {
    reportData: setReportData,
    base64String: setBase64String,
    vehicleLines: setVehicleLines,
    brand: setBrand,
    brands: setBrands,
    reportType: setReportType,
    reportTypes: setReportTypes,
    model: setModel,
    modelYears: setModelYears,
    modelYear: setModelYear,
    marketArea: setMarketArea,
    marketAreas: setMarketAreas,
    region: setRegion,
    regions: setRegions,
    zone: setZone,
    zones: setZones,
    dealership: setDealership,
    dealerships: setDealerships,
    allRegions: setAllRegions,
    regionsByMarketArea: setRegionsByMarketArea,
    zonesByMarketArea: setZonesByMarketArea,
    zonesByRegion: setZonesByRegion,
    fordDealershipsByZone: setFordDealershipsByZone,
    lincolnDealershipsByZone: setLincolnDealershipsByZone,
    salesCodeMap: setSalesCodeMap,
    dateRange: setDateRange,
    dateRanges: setDateRanges,
    previouslySelectedReportType: setPreviouslySelectedReportType,
    searchBySalesCode: setSearchBySalesCode,
    salesCode: setSalesCode,
    invalidSalesCodeError: setInvalidSalesCodeError,
    fromDate: setFromDate,
    toDate: setToDate,
    transactionDataChecked: setTransactionDataChecked,
    tradeInDataChecked: setTradeInDataChecked,
    dateRangeMethod: setDateRangeMethod,
    renderPreview: setRenderPreview,
    renderDealerDetailsSection: setRenderDealerDetailsSection,
    allZones: setAllZones,
    dealerInfo: setDealerInfo,
  };

  const setState = (updater) => {
    const nextState = typeof updater === "function" ? updater(state) : updater;
    Object.entries(nextState).forEach(([key, value]) => {
      if (stateSetters[key]) {
        stateSetters[key](value);
      }
    });
  };

  useEffect(() => {
    props.hideOrShow(true);
    LocationDataClient.getLocationData(props.user)
      .then((res) => {
        setState({
          marketAreas: state.marketAreas.concat(res.allMarketAreas),
          regions: state.regions.concat(res.allRegions),
          allRegions: state.regions.concat(res.allRegions),
          allZones: res.allZones,
          regionsByMarketArea: res.regionsByMarketArea,
          zonesByMarketArea: res.zonesByMarketArea,
          zonesByRegion: res.zonesByRegion,
          fordDealershipsByZone: res.fordDealershipsByZone,
          lincolnDealershipsByZone: res.lincolnDealershipsByZone,
          salesCodeMap: res.salesCodeCommonIdMap,
          dealerInfo: null,
        });
        props.hideOrShow(false);
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        props.hideOrShow(false);
      });
    props.hideOrShow(true);
    VehicleLinesClient.getVehicleLines(
      props.user,
      state.brand === "Ford Brand" ? "FORD" : "LINCOLN"
    )
      .then((res) => {
        setState({ vehicleLines: res });
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        props.hideOrShow(false);
      });
  }, []);

  const handleBrandChange = (e) => {
    let dealerships = [];
    const vehicleLines = {};
    const brand = e.target.value === "Ford Brand" ? "FORD" : "LINCOLN";

    if (state.zone !== props.t("fieldReporting.dropDowns.select")) {
      if (
        e.target.value === "Ford Brand" &&
        state.fordDealershipsByZone[state.zone] &&
        state.fordDealershipsByZone[state.zone].length > 0
      ) {
        dealerships = Object.values(
          state.fordDealershipsByZone[state.zone]
        );
      } else if (
          state.lincolnDealershipsByZone[state.zone] &&
          state.lincolnDealershipsByZone[state.zone].length > 0
        )
          dealerships = Object.values(
            state.lincolnDealershipsByZone[state.zone]
          );

      if (dealerships.length > 0) {
        dealerships = dealerships
          .filter((dealer) => dealer.regionDesc === state.region)
          .map((dealer) => dealer.dealerName);
      }
    }

    props.hideOrShow(true);
    VehicleLinesClient.getVehicleLines(props.user, brand)
      .then((res) => {
        setState({ vehicleLines: res });
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        props.hideOrShow(false);
      });

    setState({
      brand: e.target.value,
      dealerships,
      vehicleLines,
      model: props.t("fieldReporting.dropDowns.all"),
      modelYear: props.t("fieldReporting.dropDowns.all"),
      marketArea: props.t("fieldReporting.dropDowns.select"),
      region: props.t("fieldReporting.dropDowns.select"),
      zone: props.t("fieldReporting.dropDowns.select"),
      dealership: props.t("fieldReporting.dropDowns.select"),
    });
  };

  const handleTypeChange = (e) => {
    setState({
      reportType: e.target.value,
      transactionDataChecked: false,
      tradeInDataChecked: false,
    });
  };

  const handleModelChange = (e) => {
    const model = e.target.value;
    const modelYear = props.t("fieldReporting.dropDowns.all");
    if (model === "All") {
      setState({
        model,
        modelYear,
        modelYears: [],
      });
    } else {
      const modelYears = state.vehicleLines[model].map(
        (vehicle) => vehicle.year
      );
      setState({
        model,
        modelYear,
        modelYears,
      });
    }
  };

  const handleModelYearChange = (e) => {
    setState({ modelYear: e.target.value });
  };

  const handleMarketAreaChange = (e) => {
    const value = e.target.value;
    const all = props.t("fieldReporting.dropDowns.all");
    const select = props.t("fieldReporting.dropDowns.select");
    const isAll = value === all;
    const isSelect = value === select;
    const isLincolnBrand = state.brand === "Lincoln Brand";
    const defaultState = {
      marketArea: value,
      zone: select,
      dealership: select,
    };

    if (isAll && (state.region !== all || isLincolnBrand)) {
      setState({
        ...defaultState,
        zones: isLincolnBrand ? state.allZones : [],
        regions: isLincolnBrand ? [] : Object.values(state.allRegions),
        region: select,
      });
      return;
    }

    if (isAll && (state.region === all || isLincolnBrand)) {
      setState({
        ...defaultState,
        zones: isLincolnBrand ? state.allZones : [],
      });
      return;
    }

    if (!isSelect && !isAll) {
      setState({
        ...defaultState,
        regions: Object.values(state.regionsByMarketArea[value]),
        region: select,
        zones: isLincolnBrand
          ? Object.values(state.zonesByMarketArea[value])
          : [],
      });
      return;
    }

    setState({
      ...defaultState,
      regions: Object.values(state.allRegions),
      region: select,
      zones: isLincolnBrand ? Object.values(state.allZones) : [],
    });
  };

  const handleRegionChange = (e) => {
    if (e.target.value === props.t("fieldReporting.dropDowns.all")) {
      setState({
        region: e.target.value,
        zone: props.t("fieldReporting.dropDowns.select"),
        dealership: props.t("fieldReporting.dropDowns.select"),
      });
    } else {
      setState({
        region: e.target.value,
        zone: props.t("fieldReporting.dropDowns.select"),
        dealership: props.t("fieldReporting.dropDowns.select"),
        zones:
          e.target.value === props.t("fieldReporting.dropDowns.select")
            ? []
            : Object.values(state.zonesByRegion[e.target.value]),
      });
    }
  };

  const handleZoneChange = (e) => {
    if (e.target.value === props.t("fieldReporting.dropDowns.all")) {
      setState({
        zone: e.target.value,
        dealership: props.t("fieldReporting.dropDowns.select"),
      });
    } else {
      const zone = e.target.value;
      let dealerships = [];
      if (state.brand === "Ford Brand") {
        if (
          state.fordDealershipsByZone[zone] &&
          state.fordDealershipsByZone[zone].length > 0
        ) {
          dealerships = Object.values(state.fordDealershipsByZone[zone]);
        }
      } else if (
          state.lincolnDealershipsByZone[zone] &&
          state.lincolnDealershipsByZone[zone].length > 0
        ) {
          dealerships = Object.values(
            state.lincolnDealershipsByZone[zone]
          );
        }

      if (dealerships.length > 0) {
        if (state.brand === "Ford Brand") {
          dealerships = dealerships.filter(
            (dealer) => dealer.regionDesc === state.region
          );
        }
        dealerships = dealerships.map((dealer) => dealer.dealerName);
      }
      setState({
        zone,
        dealerships,
        dealership: props.t("fieldReporting.dropDowns.select"),
      });
    }
  };

  const handleDealershipChange = (e) => {
    setState({ dealership: e.target.value });
  };

  const handleDateRangeChange = (e) => {
    setState({ dateRange: e.target.value });
  };

  const handleSave = () => {};

  const handleSalesCodeChange = (e) => {
    setState({
      salesCode: e.target.value,
    });
  };

  const handleFromDateChange = (date) => {
    if (date !== null) {
      setState({
        fromDate: date,
      });
    }
  };

  const handleToDateChange = (date) => {
    if (date !== null) {
      setState({
        toDate: date,
      });
    }
  };

  const getTodayDate = () => {
    const today = new Date();
    return `${today.getMonth() + 1}-${today.getDate()}-${today.getFullYear()}`;
  };

  const downloadPurchaseRequestReport = (reportName, commonId) => {
    props.hideOrShow(true);
    const reqData = {
      reportType: state.reportType,
      marketArea: state.searchBySalesCode ? "" : state.marketArea,
      salesCode: state.searchBySalesCode ? state.salesCode : "",
      region: state.region,
      zone: state.zone,
      dealership: state.dealership,
      daterange:
        state.dateRangeMethod === "manual" ? "" : state.dateRange,
      dateFrom:
        state.dateRangeMethod === "manual"
          ? UiDateUtils.formatDateMmDdYyyy(state.fromDate)
          : "",
      dateTo:
        state.dateRangeMethod === "manual"
          ? UiDateUtils.formatDateMmDdYyyy(state.toDate)
          : "",
    };
    DealerReportingClient.downloadPurchaseRequestReportInCsv(
      props.user,
      props.lang,
      commonId.split("|").join("%7C"),
      state.transactionDataChecked,
      state.tradeInDataChecked,
      reqData
    )
      .then((res) => {
        const filename = reportName + " - " + getTodayDate() + ".xlsx";
        const BOM = "\uFEFF";
        const response = BOM + res;
        base64FileDownload(
          decodeURIComponent(response),
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          filename
        );
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        props.hideOrShow(false);
      });
  };

  const downloadDealerReservationReport = (reportName, commonId) => {
    props.hideOrShow(true);
    const reqData = {
      reportType: state.reportType,
      marketArea: state.searchBySalesCode ? "" : state.marketArea,
      salesCode: state.searchBySalesCode ? state.salesCode : "",
      region: state.region,
      zone: state.zone,
      dealership: state.dealership,
      daterange:
        state.dateRangeMethod === "manual" ? "" : state.dateRange,
      dateFrom:
        state.dateRangeMethod === "manual"
          ? UiDateUtils.formatDateMmDdYyyy(state.fromDate)
          : "",
      dateTo:
        state.dateRangeMethod === "manual"
          ? UiDateUtils.formatDateMmDdYyyy(state.toDate)
          : "",
    };
    DealerReportingClient.downloadDealerReservationReportInCsv(
      props.user,
      props.lang,
      commonId.split("|").join("%7C"),
      state.transactionDataChecked,
      reqData
    )
      .then((res) => {
        const filename = reportName + " - " + getTodayDate() + ".xlsx";
        const BOM = "\uFEFF";
        const response = BOM + res;
        base64FileDownload(
          decodeURIComponent(response),
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          filename
        );
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        props.hideOrShow(false);
      });
  };

  const downloadOrderConversionReport = (reportName, commonId) => {
    props.hideOrShow(true);
    const reqData = {
      reportType: state.reportType,
      marketArea: state.searchBySalesCode ? "" : state.marketArea,
      salesCode: state.searchBySalesCode ? state.salesCode : "",
      region: state.region,
      zone: state.zone,
      dealership: state.dealership,
      daterange:
        state.dateRangeMethod === "manual" ? "" : state.dateRange,
      dateFrom:
        state.dateRangeMethod === "manual"
          ? UiDateUtils.formatDateMmDdYyyy(state.fromDate)
          : "",
      dateTo:
        state.dateRangeMethod === "manual"
          ? UiDateUtils.formatDateMmDdYyyy(state.toDate)
          : "",
    };
    DealerReportingClient.downloadOrderConversionReportInCsv(
      props.user,
      props.lang,
      commonId.split("|").join("%7C"),
      state.transactionDataChecked,
      reqData
    )
      .then((res) => {
        const filename = reportName + " - " + getTodayDate() + ".xlsx";
        const BOM = "\uFEFF";
        const response = BOM + res;
        base64FileDownload(
          decodeURIComponent(response),
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          filename
        );
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        props.hideOrShow(false);
      });
  };

  const resetForm = () => {
    if (salesCodeInput?.current) {
      salesCodeInput.current.value = "";
    }

    setState({
      brand: props.t("fieldReporting.dropDowns.fordBrand"),
      reportType: props.t("fieldReporting.dropDowns.purchaseRequest"),
      marketArea: props.t("fieldReporting.dropDowns.select"),
      region: props.t("fieldReporting.dropDowns.select"),
      zone: props.t("fieldReporting.dropDowns.select"),
      dealership: props.t("fieldReporting.dropDowns.select"),
      dateRange: props.t("fieldReporting.dropDowns.last30Days"),
      model: props.t("fieldReporting.dropDowns.all"),
      modelYear: props.t("fieldReporting.dropDowns.all"),
      modelYears: [],
      salesCode: null,
      fromDate: new Date(),
      toDate: new Date(),
      dateRangeMethod: "auto",
    });
  };

  const toggleTradeInData = () => {
    setState((prevState) => ({
      tradeInDataChecked: !prevState.tradeInDataChecked,
    }));
  };

  const toggleTransactionData = () => {
    setState((prevState) => ({
      transactionDataChecked: !prevState.transactionDataChecked,
    }));
  };

  const getFordSelectionTypeValues = (all, select) => {
    const rules = [
      {
        matches: state.marketArea === all && state.region === select,
        totalKey: "fieldReporting.nationalTotal",
        filterType: "All Market Areas - ",
      },
      {
        matches:
          state.marketArea !== all &&
          state.marketArea !== select &&
          state.region === select,
        totalKey: "fieldReporting.nationalTotal",
        filterType: `${state.marketArea} - `,
      },
      {
        matches:
          state.marketArea === all && state.region === all && state.zone === select,
        totalKey: "fieldReporting.nationalTotal",
        filterType: "All Market Areas - All Regions - ",
      },
      {
        matches:
          state.marketArea === all &&
          state.region !== all &&
          state.region !== select &&
          state.zone === select,
        totalKey: "fieldReporting.regionalTotal",
        filterType: `All Market Areas - ${state.region} - ${state.dateRange}`,
      },
      {
        matches:
          state.marketArea === all &&
          state.region !== all &&
          state.region !== select &&
          state.zone === all &&
          state.dealership === select,
        totalKey: "fieldReporting.regionalTotal",
        filterType: `All Market Areas - ${state.region} - All Zones - `,
      },
      {
        matches:
          state.marketArea === all &&
          state.region !== all &&
          state.region !== select &&
          state.zone !== all &&
          state.zone !== select &&
          state.dealership === select,
        totalKey: "fieldReporting.regionalTotal",
        filterType: `All Market Areas - ${state.region} - ${state.zone} - `,
      },
      {
        matches:
          state.marketArea === all &&
          state.region !== all &&
          state.region !== select &&
          state.zone !== all &&
          state.zone !== select &&
          state.dealership === all,
        totalKey: "fieldReporting.zoneTotal",
        filterType: `All Market Areas - ${state.region} - ${state.zone} - All Dealerships - `,
      },
      {
        matches:
          state.marketArea === all &&
          state.region !== all &&
          state.region !== select &&
          state.zone !== all &&
          state.zone !== select &&
          state.dealership !== all &&
          state.dealership !== select,
        totalKey: "fieldReporting.dealershipTotal",
        filterType: `All Market Areas - ${state.region} - ${state.zone} - ${state.dealership} - `,
      },
      {
        matches:
          state.marketArea !== select &&
          state.marketArea !== all &&
          state.region === all &&
          state.zone === select,
        totalKey: "fieldReporting.nationalTotal",
        filterType: `${state.marketArea} - All Regions - `,
      },
      {
        matches:
          state.marketArea !== select &&
          state.marketArea !== all &&
          state.region !== select &&
          state.region !== all &&
          state.zone === all &&
          state.dealership === select,
        totalKey: "fieldReporting.regionalTotal",
        filterType: `${state.marketArea} - ${state.region} - All Zones - `,
      },
      {
        matches:
          state.marketArea !== select &&
          state.marketArea !== all &&
          state.region !== select &&
          state.region !== all &&
          state.zone === select,
        totalKey: "fieldReporting.regionalTotal",
        filterType: `${state.marketArea} - Region ${state.region} - `,
      },
      {
        matches:
          state.marketArea !== select &&
          state.marketArea !== all &&
          state.region !== select &&
          state.region !== all &&
          state.zone !== all &&
          state.zone !== select &&
          state.dealership === select,
        totalKey: "fieldReporting.zoneTotal",
        filterType: `${state.marketArea} - ${state.region} - ${state.zone} - `,
      },
      {
        matches:
          state.marketArea !== all &&
          state.marketArea !== select &&
          state.region !== select &&
          state.region !== all &&
          state.zone !== all &&
          state.zone !== select &&
          state.dealership === all,
        totalKey: "fieldReporting.zoneTotal",
        filterType: `${state.marketArea} - ${state.region} - ${state.zone} - All Dealerships - `,
      },
      {
        matches:
          state.marketArea !== all &&
          state.marketArea !== select &&
          state.region !== select &&
          state.region !== all &&
          state.zone !== all &&
          state.zone !== select &&
          state.dealership !== select &&
          state.dealership !== all,
        totalKey: "fieldReporting.dealershipTotal",
        filterType: `${state.marketArea} - ${state.region} - ${state.zone} - ${state.dealership} - `,
      },
    ];

    const matchedRule = rules.find((rule) => rule.matches);
    if (!matchedRule) return { totalType: undefined, filterType: undefined };
    return {
      totalType: props.t(matchedRule.totalKey),
      filterType: matchedRule.filterType,
    };
  };

  const getLincolnSelectionTypeValues = (all, select) => {
    const rules = [
      {
        matches: state.marketArea === all && state.zone === select,
        totalKey: "fieldReporting.nationalTotal",
        filterType: "All Market Areas - ",
      },
      {
        matches:
          state.marketArea !== all &&
          state.marketArea !== select &&
          state.zone === select,
        totalKey: "fieldReporting.nationalTotal",
        filterType: `${state.marketArea} - `,
      },
      {
        matches:
          state.marketArea === all &&
          state.zone === all &&
          state.dealership === select,
        totalKey: "fieldReporting.nationalTotal",
        filterType: "All Market Areas - All Zones - ",
      },
      {
        matches:
          state.marketArea !== all &&
          state.marketArea !== select &&
          state.zone === all,
        totalKey: "fieldReporting.nationalTotal",
        filterType: `${state.marketArea} - All Zones - `,
      },
      {
        matches:
          state.marketArea !== all &&
          state.marketArea !== select &&
          state.zone !== all &&
          state.zone !== select &&
          state.dealership === select,
        totalKey: "fieldReporting.nationalTotal",
        filterType: `${state.marketArea} - ${state.zone} - `,
      },
      {
        matches:
          state.marketArea === all &&
          state.zone !== all &&
          state.zone !== select &&
          state.dealership === select,
        totalKey: "fieldReporting.nationalTotal",
        filterType: `All Market Areas - ${state.zone} - `,
      },
      {
        matches:
          state.marketArea === all &&
          state.zone !== all &&
          state.zone !== select &&
          state.dealership !== all &&
          state.dealership !== select,
        totalKey: "fieldReporting.nationalTotal",
        filterType: `All Market Areas - ${state.zone} - ${state.dealership} - `,
      },
      {
        matches:
          state.marketArea === all &&
          state.zone !== all &&
          state.zone !== select &&
          state.dealership === all,
        totalKey: "fieldReporting.nationalTotal",
        filterType: `All Market Areas - ${state.zone} - All Dealerships - `,
      },
      {
        matches:
          state.marketArea !== all &&
          state.marketArea !== select &&
          state.zone !== all &&
          state.zone !== select &&
          state.dealership !== all &&
          state.dealership !== select,
        totalKey: "fieldReporting.nationalTotal",
        filterType: `${state.marketArea} - ${state.zone} - ${state.dealership} - `,
      },
      {
        matches:
          state.marketArea !== all &&
          state.marketArea !== select &&
          state.zone !== all &&
          state.zone !== select &&
          state.dealership === all,
        totalKey: "fieldReporting.nationalTotal",
        filterType: `${state.marketArea} - ${state.zone} - All Dealerships - `,
      },
    ];

    const matchedRule = rules.find((rule) => rule.matches);
    if (!matchedRule) return { totalType: undefined, filterType: undefined };
    return {
      totalType: props.t(matchedRule.totalKey),
      filterType: matchedRule.filterType,
    };
  };

  const getSelectionTypeValues = () => {
    const all = props.t("fieldReporting.dropDowns.all");
    const select = props.t("fieldReporting.dropDowns.select");
    if (state.searchBySalesCode) {
      return { totalType: undefined, filterType: `${state.salesCode} - ` };
    }
    if (state.brand === "Ford Brand") {
      return getFordSelectionTypeValues(all, select);
    }
    return getLincolnSelectionTypeValues(all, select);
  };

  const updateSelectionTypes = () => {
    const { totalType, filterType } = getSelectionTypeValues();
    let date;
    if (state.dateRangeMethod === "auto") {
      date = isFordBrand
        ? UpperCaseText(state.dateRange)
        : state.dateRange;
    } else {
      date =
        "FROM " +
        UiDateUtils.formatDateMmDdYyyy(state.fromDate) +
        " TO " +
        UiDateUtils.formatDateMmDdYyyy(state.toDate);
    }
    setState({
      selectionTypes: {
        totalType: totalType,
        filterType: filterType,
        dateRange: date,
        model:
          state.model === "All"
            ? props.t("fieldReporting.allModels")
            : state.model,
        modelYear:
          state.modelYear === "All"
            ? props.t("fieldReporting.allModelYears")
            : state.modelYear,
      },
    });
  };

  const updateSearchType = () => {
    setState((prevState) => ({
      searchBySalesCode: !prevState.searchBySalesCode,
      marketArea: props.t("fieldReporting.dropDowns.select"),
      region: props.t("fieldReporting.dropDowns.select"),
      zone: props.t("fieldReporting.dropDowns.select"),
      dealership: props.t("fieldReporting.dropDowns.select"),
      salesCode: null,
      invalidSalesCodeError: false,
    }));
  };

  const toggleRadio = (e) => {
    setState({ dateRangeMethod: e.target.value });
  };

  const downloadFieldReport = () => {
    props.hideOrShow(true);
    let reportName = "FieldReport";
    const today = new Date();
    if (state.reportType === "Orders & conversions") {
      reportName =
        "Report-Orders-" + UiDateUtils.formatDateMmDdYyyy(today) + ".xlsx";
    } else if (state.reportType === "Reservations & conversions") {
      reportName =
        "Report-Reservations-" +
        UiDateUtils.formatDateMmDdYyyy(today) +
        ".xlsx";
    } else if (state.reportType === "Purchase Request") {
      reportName =
        "Report-PurchaseRequest-" +
        UiDateUtils.formatDateMmDdYyyy(today) +
        ".xlsx";
    }
    const BOM = "\uFEFF";
    const response = BOM + state.base64String;
    base64FileDownload(
      decodeURIComponent(response),
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      reportName
    );
    props.hideOrShow(false);
  };

  const downloadDealerReport = () => {
    let commonId;
    if (state.searchBySalesCode) {
      const normalizedSalesCode = UpperCaseText(state.salesCode);
      let salesCodeLookupKey = normalizedSalesCode;

      if (!IS_USA_MARKET) {
        salesCodeLookupKey = IS_FORD_BRAND
          ? `F${normalizedSalesCode}`
          : `L${normalizedSalesCode}`;
      }

      commonId = state.salesCodeMap[salesCodeLookupKey];
    } else {
      const dealerships =
        state.brand === "Ford Brand"
          ? Object.values(state.fordDealershipsByZone[state.zone])
          : Object.values(state.lincolnDealershipsByZone[state.zone]);

      commonId = dealerships.find(
        (dealership) => dealership.dealerName === state.dealership
      ).commonId;
    }

    switch (state.reportType) {
      case props.t("fieldReporting.dropDowns.reservationsConversions"):
        downloadDealerReservationReport(
          props.t("fieldReporting.dropDowns.reservationsConversions"),
          commonId
        );
        break;
      case props.t("fieldReporting.dropDowns.ordersConversions"):
        downloadOrderConversionReport(
          props.t("fieldReporting.dropDowns.ordersConversions"),
          commonId
        );
        break;
      case props.t("fieldReporting.dropDowns.purchaseRequest"):
        downloadPurchaseRequestReport(
          props.t("fieldReporting.dropDowns.purchaseRequest"),
          commonId
        );
        break;
      default:
        break;
    }
  };

  const getFieldReport = () => {
    props.hideOrShow(true);
    let invalidSalesCodeError = false;
    let renderPreview = true;

    if (state.searchBySalesCode) {
      const validBrand =
        (state.salesCode &&
          UpperCaseText(state.salesCode.charAt(0)) === "F") ||
        UpperCaseText(state.salesCode.charAt(0)) === "L";
      const code = state.salesCode?.substring(1);

      if (!validBrand || !code.match(String.raw`\b\d{5}\b`)) {
        invalidSalesCodeError = true;
        renderPreview = false;
      } else {
        DealerGroupingClient.getDealerGroup(
          props.user,
          state.salesCode,
          null,
          true
        )
          .then((response) => {
            if (response[0] === null) {
              invalidSalesCodeError = true;
              renderPreview = false;
            } else {
              setState({ dealerInfo: response });
            }
          })
          .catch(() => {
            invalidSalesCodeError = true;
            renderPreview = false;
          });
      }
    }
    let filteredReportType = state.reportType.replaceAll(' ', "");
    filteredReportType = filteredReportType.replace("&", "-");
    updateSelectionTypes();
    const reqBody = {
      reportType: filteredReportType,
      model:
        state.model === props.t("fieldReporting.dropDowns.all")
          ? null
          : state.model,
      modelYear:
        state.modelYear === props.t("fieldReporting.dropDowns.all")
          ? null
          : state.modelYear,
      marketArea: state.marketArea,
      salesCode: state.salesCode,
      region: state.region,
      zone: state.zone,
      dealership: state.dealership,
      dateRange:
        state.dateRangeMethod === "auto" ? state.dateRange : "",
      dateFrom:
        state.dateRangeMethod === "manual"
          ? UiDateUtils.formatDateMmDdYyyy(state.fromDate)
          : "",
      dateTo:
        state.dateRangeMethod === "manual"
          ? UiDateUtils.formatDateMmDdYyyy(state.toDate)
          : "",
      brand: state.brand === "Ford Brand" ? "ford" : "lincoln",
    };
    DealerReportingClient.getFieldReport(props.user, reqBody)
      .then((res) => {
        setState({
          reportData: res?.fieldReport,
          base64String: res?.base64String,
          renderPreview: renderPreview,
          renderDealerDetailsSection:
            renderPreview &&
            ((state.dealership &&
              state.dealership !==
                props.t("fieldReporting.dropDowns.select") &&
              state.dealership !==
                props.t("fieldReporting.dropDowns.all")) ||
              state.salesCode),
          previouslySelectedReportType: state.reportType,
          invalidSalesCodeError: invalidSalesCodeError,
        });
      })
      .catch((reason) => {
        logMsg("reason", reason);
        setState({
          renderPreview: false,
          renderDealerDetailsSection: false,
        });
      })
      .finally(() => {
        props.hideOrShow(false);
      });
  };

  const updateStyles = () => {
    isFordBrand = IS_FORD_BRAND(props.brand);
    stylesOverride = isFordBrand ? fordStylesOverride : lincolnStylesOverride;
    document.body.style.backgroundColor = isFordBrand ? "#ffffff" : "#f6f7f7";
    styles = isFordBrand ? fordStyles : lincolnStyles;
  };

  props.user.updateBrand(props.user.dealerBrand);
  publish("brandChanged", props.user.dealerBrand);
  updateStyles();

  const renderReportPreview = () => {
    if (!state.renderPreview) {
      return (
        <div className={styles.reportErrorLabel}>
          {props.t("fieldReporting.reportPreviewError")}
        </div>
      );
    }

    if (
      state.previouslySelectedReportType ===
      props.t("fieldReporting.dropDowns.reservationsConversions")
    ) {
      return (
        <ReservationsPreview
          {...props}
          data={state.reportData?.reservationsAndConversions}
          renderPreview={state.renderPreview}
          downloadFieldReport={downloadFieldReport}
          selectionTypes={state.selectionTypes}
          dealerInfo={state.dealerInfo}
        />
      );
    }

    if (
      state.previouslySelectedReportType ===
      props.t("fieldReporting.dropDowns.ordersConversions")
    ) {
      return (
        <OrdersPreview
          {...props}
          data={state.reportData?.ordersAndConversions}
          renderPreview={state.renderPreview}
          downloadFieldReport={downloadFieldReport}
          selectionTypes={state.selectionTypes}
          dealerInfo={state.dealerInfo}
        />
      );
    }

    if (
      state.previouslySelectedReportType ===
      props.t("fieldReporting.dropDowns.purchaseRequest")
    ) {
      return (
        <PurchaseRequestPreview
          {...props}
          data={state.reportData?.purchaseRequest}
          renderPreview={state.renderPreview}
          downloadFieldReport={downloadFieldReport}
          selectionTypes={state.selectionTypes}
          dealerInfo={state.dealerInfo}
        />
      );
    }

    return null;
  };

  const renderContent = () => (
      <div
        key={
          "brand_reporting_" +
          props.user.dealerBrand +
          "_" +
          state.brand
        }
      >
        <section className="pageWrapper">
          <div className={styles.blueBar} />

          <div className={styles.pagePadding}>
            <div className={styles.header}>
              <div className={styles.title}>
                {props.t("fieldReporting.reporting")}
              </div>

              <div className={styles.dropDownsWrapper}>
                <div className={styles.dropdownDiv}>
                  <DropDown
                    {...props}
                    id="brand"
                    hideDefaultItems={true}
                    onDropdownChange={handleBrandChange}
                    items={state.brands}
                    selectedValue={state.brand}
                  />
                </div>
              </div>
            </div>

            <div className={styles.subTitle}>
              {props.t("fieldReporting.generateReport")}
            </div>
          </div>

          <div className={styles.topDivider} />

          <div className={styles.pagePadding}>
            <Grid container>
              <Grid item xs={3} style={stylesOverride.gridItem}>
                {props.t("fieldReporting.reportType")}
              </Grid>
            </Grid>

            <div className={styles.typeAndRegionWrapper}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <div className={styles.dropDown}>
                    <div className={styles.dropDownLabel}>
                      {props.t("fieldReporting.type")}
                    </div>
                    <div>
                      <DropDown
                        {...props}
                        id="type"
                        onDropdownChange={handleTypeChange}
                        items={state.reportTypes}
                        selectedValue={state.reportType}
                        hideDefaultItems={true}
                        fullWidth={true}
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <div className={styles.dropDown}>
                    <div className={styles.dropDownLabel}>
                      {props.t("fieldReporting.model")}
                    </div>
                    <div>
                      <DropDown
                        {...props}
                        id="model"
                        onDropdownChange={handleModelChange}
                        items={Object.keys(state.vehicleLines)}
                        selectedValue={state.model}
                        showAggregate={true}
                        fullWidth={true}
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <div className={styles.dropDown}>
                    <div className={styles.dropDownLabel}>
                      {props.t("fieldReporting.modelYear")}
                    </div>
                    <div>
                      <DropDown
                        {...props}
                        id="modelYear"
                        onDropdownChange={handleModelYearChange}
                        items={state.modelYears}
                        selectedValue={state.modelYear}
                        modelYear={true}
                      />
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>

            <Grid item xs={12}>
              <span className={styles.locationLabel}>
                {props.t("fieldReporting.reportLocation")}
              </span>
              <span className={styles.locationLabelSub}>
                {props.t("fieldReporting.reportLocationSub")}
              </span>
            </Grid>

            <div className={styles.typeAndRegionWrapper}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={3}>
                  {state.searchBySalesCode ? (
                    <ValidatorForm onSubmit={handleSave}>
                      <div className={styles.dropDownLabel}>
                        {props.t("fieldReporting.enterSalesCode")}
                      </div>
                      <TextValidator
                        name="searchBySalesCode"
                        id="searchBySalesCode"
                        data-testid="searchBySalesCode"
                        value={state.salesCode}
                        inputRef={salesCodeInput}
                        onChange={handleSalesCodeChange}
                        className={styles.searchInput}
                      />
                    </ValidatorForm>
                  ) : (
                    <div className={styles.dropDown}>
                      <div className={styles.dropDownLabel}>
                        {props.t("fieldReporting.marketArea")}
                      </div>
                      <div>
                        <DropDown
                          {...props}
                          id="marketArea"
                          onDropdownChange={handleMarketAreaChange}
                          items={state.marketAreas}
                          selectedValue={state.marketArea}
                        />
                      </div>
                    </div>
                  )}
                </Grid>

                {!state.searchBySalesCode &&
                  state.brand === "Ford Brand" && (
                    <Grid item xs={12} sm={3}>
                      <div>
                        <div
                          className={
                            state.marketArea ===
                            props.t("fieldReporting.dropDowns.select")
                              ? styles.dropDownLabelDisabled
                              : styles.dropDownLabel
                          }
                        >
                          {props.t("fieldReporting.region")}
                        </div>
                        <div>
                          <DropDown
                            {...props}
                            id="region"
                            onDropdownChange={handleRegionChange}
                            items={state.regions}
                            selectedValue={state.region}
                            disabled={
                              state.marketArea ===
                              props.t("fieldReporting.dropDowns.select")
                            }
                          />
                        </div>
                      </div>
                    </Grid>
                  )}

                {!state.searchBySalesCode && (
                  <Grid item xs={12} sm={3}>
                    <div className={styles.dropDown}>
                      <div
                        className={
                          (state.brand === "Lincoln Brand" &&
                            state.marketArea ===
                              props.t(
                                "fieldReporting.dropDowns.select"
                              )) ||
                          (state.brand === "Ford Brand" &&
                            state.region ===
                              props.t(
                                "fieldReporting.dropDowns.select"
                              )) ||
                          (state.brand === "Ford Brand" &&
                            state.marketArea ===
                              props.t("fieldReporting.dropDowns.all") &&
                            state.region ===
                              props.t("fieldReporting.dropDowns.all"))
                            ? styles.dropDownLabelDisabled
                            : styles.dropDownLabel
                        }
                      >
                        {props.t("fieldReporting.zone")}
                      </div>
                      <div>
                        <DropDown
                          {...props}
                          id="zone"
                          onDropdownChange={handleZoneChange}
                          items={state.zones}
                          selectedValue={state.zone}
                          disabled={
                            state.brand === "Ford Brand"
                              ? state.region ===
                                  props.t(
                                    "fieldReporting.dropDowns.select"
                                  ) ||
                                state.region ===
                                  props.t("fieldReporting.dropDowns.all")
                              : state.marketArea ===
                                props.t("fieldReporting.dropDowns.select")
                          }
                        />
                      </div>
                    </div>
                  </Grid>
                )}

                {!state.searchBySalesCode && (
                  <Grid item xs={12} sm={3}>
                    <div className={styles.dropDown}>
                      <div
                        className={
                          state.zone ===
                            props.t("fieldReporting.dropDowns.select") ||
                          state.zone ===
                            props.t("fieldReporting.dropDowns.all")
                            ? styles.dropDownLabelDisabled
                            : styles.dropDownLabel
                        }
                      >
                        {props.t("fieldReporting.dealership")}
                      </div>
                      <div>
                        <DropDown
                          {...props}
                          id="dealership"
                          onDropdownChange={handleDealershipChange}
                          items={state.dealerships}
                          selectedValue={state.dealership}
                          disabled={
                            state.zone ===
                              props.t("fieldReporting.dropDowns.select") ||
                            state.zone ===
                              props.t("fieldReporting.dropDowns.all")
                          }
                        />
                      </div>
                    </div>
                  </Grid>
                )}
              </Grid>

              <Grid container>
                <Grid item xs={12} style={stylesOverride.gridItem}>
                  <div className={styles.dropDown}>
                    {state.searchBySalesCode &&
                      state.invalidSalesCodeError && (
                        <div className={styles.error}>
                          {props.t("fieldView.salesCodeError")}
                        </div>
                      )}
                    <button
                      type="button"
                      className={styles.searchByLink}
                      onClick={updateSearchType}
                    >
                      {state.searchBySalesCode
                        ? props.t("fieldReporting.searchByDropdown")
                        : props.t("fieldReporting.searchBySalesCode")}
                    </button>
                  </div>
                </Grid>
              </Grid>
            </div>

            <Grid container>
              <Grid item xs={7} style={stylesOverride.gridItem}>
                <span className={styles.dateRange}>
                  {props.t("fieldReporting.dateRange")}
                </span>
                <span className={styles.dateRangeSub}>
                  {props.t("fieldReporting.dateRangeSub")}
                </span>
              </Grid>
              <Grid item xs={5} />
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <div className={styles.dateRangeWrapper}>
                  <RadioGroup
                    value={state.dateRangeMethod}
                    onChange={toggleRadio}
                  >
                    <div className={styles.dropDownDateWrapper}>
                      <FormControlLabel
                        value="auto"
                        control={<Radio />}
                        data-testid="auto"
                        checked={state.dateRangeMethod === "auto"}
                        label={
                          <div className={styles.dropDownDateWrapper}>
                            <div className={styles.dropdownAutoDate}>
                              <DropDown
                                {...props}
                                id="dateRange"
                                onDropdownChange={handleDateRangeChange}
                                items={state.dateRanges}
                                selectedValue={state.dateRange}
                              />
                            </div>
                            <div className={styles.orPadding}>
                              {props.t("fieldReporting.or")}
                            </div>
                          </div>
                        }
                      />
                    </div>
                    <FormControlLabel
                      value="manual"
                      control={<Radio />}
                      data-testid="manual"
                      checked={state.dateRangeMethod === "manual"}
                      label={
                        <div className={styles.datePickerWrapper}>
                          <div className={styles.toFromDatePickerWrapper}>
                            <div className={styles.fromLabel}>
                              {props.t("fieldReporting.from")}
                            </div>
                            <div className={styles.datePickerInputIcon}>
                              <DatePicker
                                selected={state.fromDate}
                                onChange={handleFromDateChange}
                                popperPlacement="top-end"
                                id="fromDate"
                                data-testid="fromDate"
                                maxDate={new Date()}
                                dateFormat={DateConstants.MMddyyyy}
                              />
                              <DatePickerIcon />
                            </div>
                          </div>
                          <div className={styles.dateDivider} />
                          <div className={styles.toFromDatePickerWrapper}>
                            <div className={styles.toLabel}>
                              {props.t("fieldReporting.to")}
                            </div>
                            <div className={styles.datePickerInputIcon}>
                              <DatePicker
                                selected={state.toDate}
                                onChange={handleToDateChange}
                                popperPlacement="top-end"
                                id="toDate"
                                data-testid="toDate"
                                maxDate={new Date()}
                                minDate={state.fromDate}
                                dateFormat={DateConstants.MMddyyyy}
                              />
                              <DatePickerIcon />
                            </div>
                          </div>
                        </div>
                      }
                    />
                  </RadioGroup>
                </div>
              </Grid>

              <Grid item xs={12}>
                <div className={styles.generateReport}>
                  <Reset className={styles.reset} onClick={resetForm} />
                  <button
                    type="button"
                    onClick={resetForm}
                    className={styles.resetLabel}
                  >
                    {props.t("fieldReporting.reset")}
                  </button>
                  <div className={styles.buttonContainer}>
                    <EMPButton
                      disabled={
                        state.marketArea ===
                          props.t("fieldReporting.dropDowns.select") &&
                        !state.salesCode
                      }
                      variant="contained"
                      submitButton
                      testId="runReport"
                      onClick={getFieldReport}
                    >
                      {props.t("fieldReporting.run")}
                    </EMPButton>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>

          <div className={styles.pagePadding}>
            <div className={styles.bottomDivider} />

            <div className={styles.subTitleBottom}>
              {props.t("fieldReporting.reportPreview")}
            </div>
            {renderReportPreview()}
          </div>
          {state.renderDealerDetailsSection && (
            <div className={styles.dealerDetails}>
              <div className={styles.pagePadding}>
                <div className={styles.dealerName}>
                  {`${props.t(
                    "fieldReporting.table.dealerDetailReport"
                  )} - ${UpperCaseText(state.reportType)} - ${
                    state.selectionTypes?.model || props.t("fieldReporting.dropDowns.all")
                  }, ${
                    state.selectionTypes?.modelYear ||
                    props.t("fieldReporting.dropDowns.all")
                  }`}
                </div>
                <div className={styles.dealerInfo}>
                  {isFordBrand
                    ? UpperCaseText(state.selectionTypes?.filterType || "") +
                      (state.selectionTypes?.dateRange || "")
                    : (state.selectionTypes?.filterType || "") +
                      (state.selectionTypes?.dateRange || "")}
                </div>
                <div className={styles.info}>
                  {props.t("fieldReporting.table.dealerDetailReportInfo")}
                </div>
                <div className={styles.reportToIncludeWrapper}>
                  <div className={styles.checkBoxDiv}>
                    <div className={styles.reportToIncludeLabel}>
                      {props.t("fieldReporting.table.reportToInclude")}
                    </div>
                    {state.reportType ===
                      props.t(
                        "fieldReporting.dropDowns.purchaseRequest"
                      ) && (
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="blue"
                            boldCheck={true}
                            textClass={checkboxStyles.cancelLabel}
                            checked={state.tradeInDataChecked}
                            name="tradeInData"
                            id="tradeInData"
                            onChange={toggleTradeInData}
                          />
                        }
                        label={props.t("fieldReporting.tradeInData")}
                      />
                    )}
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="blue"
                          boldCheck={true}
                          textClass={checkboxStyles.cancelLabel}
                          checked={state.transactionDataChecked}
                          name="transactionData"
                          id="transactionData"
                          onChange={toggleTransactionData}
                        />
                      }
                      label={props.t("fieldReporting.transactionData")}
                    />
                  </div>
                  <EMPButton
                    testId="downloadDealerReport"
                    onClick={downloadDealerReport}
                    variant="text"
                    leftIcon={<CloudDownloadIcon />}
                    submitButton
                  >
                    {props.t("fieldReporting.download")}
                  </EMPButton>
                </div>
              </div>
            </div>
          )}
        </section>
      </div>
    );

  return renderContent();
};

const DropDown = (props) => {
  const menuItems = [];

  if (!props.hideDefaultItems && !props.modelYear && !props.showAggregate) {
    menuItems.push({
      text: "Select",
      value: "Select",
    });
  }
  if (!props.hideDefaultItems) {
    menuItems.push({
      value: "All",
      text: props.showAggregate ? "All (Aggregate)" : "All",
    });
  }
  if (props.items) {
    props.items.forEach((item) => {
      menuItems.push({
        text: item,
        value: item,
      });
    });
  }
  return (
    <FormControl
      id={props.id}
      className={styles.modelFormControl}
      disabled={props.disabled}
      fullWidth={props.fullWidth}
    >
      <EMPSelectField
        testId={props.id}
        value={props.selectedValue}
        onChange={(e) => props.onDropdownChange(e)}
        menuItems={menuItems}
      />
    </FormControl>
  );
};

FieldReporting.propTypes = {
  brand: PropTypes.string,
  hideOrShow: PropTypes.func.isRequired,
  lang: PropTypes.string,
  t: PropTypes.func.isRequired,
  user: PropTypes.shape({
    dealerBrand: PropTypes.string,
    updateBrand: PropTypes.func,
  }).isRequired,
};

DropDown.propTypes = {
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  hideDefaultItems: PropTypes.bool,
  id: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.string),
  modelYear: PropTypes.bool,
  onDropdownChange: PropTypes.func,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showAggregate: PropTypes.bool,
};

export default withTranslation("emp")(FieldReporting);
